import React, { useEffect } from "react";
import { signal } from "@preact/signals-react";

import { layout as layoutProduct } from "../models/LayoutProduct";
import BasicTable from "componentsv2/table/BasicTable";
import { useTable } from "storev2/tableStore";

const productsSupply = signal([]);

function ViewProducts({ storeId, products }) {
  const { setTable } = useTable();
  const layoutProducts = layoutProduct();

  const attrsProducts = {
    name: "products",
    layout: layoutProducts,
    // selectable: "multi",
    currentRecordId: signal(null),
  };

  useEffect(() => {
    if (products && storeId) {
      console.log("ViewProducts setTable:", {
        storeId,
        productsLength: products.length,
        firstProduct: products[0],
      });
      setTable({
        layout: layoutProducts,
        records: products,
        storeId: storeId,
      });

      productsSupply.value = products;
    }
  }, [products, storeId]);

  if (!productsSupply.value.length)
    return (
      <div className="bg-neutral-200  p-3 w-full text-neutral-500 font-bold mt-4 text-xl rounded-md border border-neutral-300 shadow-md">
        <p className="mx-auto text-center w-full">
          No hay dotaciones asignadas para el cargo de este empleado
        </p>
      </div>
    );

  return (
    <div className="mt-10">
      <BasicTable
        {...attrsProducts}
        records={productsSupply.value}
        recordStoreId={storeId}
        storeId={storeId}
      />
    </div>
  );
}

export default ViewProducts;
